import SettingsHexaIcon from "../../../../assets/icons/react-svg/SettingsHexaIcon";
import { Link, Redirect, useHistory } from "react-router-dom";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import {
  getOrganizationInfo,
  getUserDetailsByUserId,
} from "../../../common/api-services/adminPanelApi";
import useJwtToken from "../../../config/auth/useJwtToken";
import SvgBellIcon from "../../../../assets/icons/react-svg/BellIcon";
import SvgQuickActionIcon from "../../../../assets/icons/react-svg/QuickActionIcon";
import MenuCalendarIcon from "../../../../assets/icons/react-svg/MenuCalendarIcon";
import HamburgerIcon from "../../../../assets/icons/react-svg/HamburgerIcon";
import WhatsNewIcon from "../../../../assets/icons/react-svg/WhatsNew";
import useOutsideHeaderMenuClick from "../../../common/hooks/useOutsideHeaderMenuClick";
import styles from "./Header.module.css";
import Loader from "../../shared/loaders/Loader";
import useOnWindowResize from "../../../common/hooks/useOnWindowResize";
import Cookies from "js-cookie";
import { getUserProfilePicById } from "../../../common/api-services/userApi";
import { environment } from "../../../config/environments/environment";
import { useDispatch, useSelector } from "react-redux";
import { getSecondsUntilPasswordExpiry } from "../../../config/auth/useRefreshToken";
import { RootState } from "../../../redux/store";
import { setMixpanelEventForLogOut } from "../../../common/mixpanel-events/logout";
import { userLogout } from "../../../redux/slices/logout";
import isElectron from "is-electron";
import { SubMenuDownArrow } from "../../../../assets/icons";
import axios from "axios";
import { setMatrixState } from "../../../redux/slices/showMatrixChatSlice";
import { useLanguage } from "../../../../context/LanguageContext";
import { matrixUserLogout } from "../../../common/api-services/headerApi";
import { writeLogoutEvent } from "../../../config/firebase/firebase-config";
import { isMobile } from "react-device-detect";

function formatPwdTimeLeft(secs: number): string {
  if (secs < 60) return `${Math.floor(secs)} second${Math.floor(secs) !== 1 ? 's' : ''}`;
  if (secs < 3600) return `${Math.floor(secs / 60)} minute${Math.floor(secs / 60) !== 1 ? 's' : ''}`;
  if (secs < 86400) return `${Math.floor(secs / 3600)} hour${Math.floor(secs / 3600) !== 1 ? 's' : ''}`;
  return `${Math.floor(secs / 86400)} day${Math.floor(secs / 86400) !== 1 ? 's' : ''}`;
}

export default function Header() {
  const { t } = useLanguage();
  const { language, setLanguage } = useLanguage();
  const history = useHistory();
  const userInfo = useJwtToken();
  const clickRef = useRef<any>(null);
  const containerRef = useRef<any>(null);
  const menuRef = useRef<any>(null);
  const burgerRef = useRef<any>(null);
  const burgerDiv = useRef<any>(null);
  const [pictureUrl, setPictureUrl] = useState<string>("");
  const [imageLoadError, setImageLoadError] = useState<boolean>(false);
  const [userMenuVisible, setUserMenuVisible] = useState<boolean>(false);
  const [mainMenuVisible, setMainMenuVisible] = useState<boolean>(false);
  const profilePage = userInfo?.user.profile_page;
  const logOutUrl = userInfo?.user.logout_url;
  // const userTitle = userInfo?.user.organization_name;
  const [userAvatarLetter, setUserAvatarLetter] = useState<string>("");
  const [organizationName, setOrganizationName] = useState<any>();
  const [userName, setUserName] = useState<any>();
  const [chatClass, setChatClass] = useState(false);
  const [organizationLogo, setOrganizationLogo] = useState<any>();
  const [firstOrgWord, setFirstOrgWord] = useState<any>();
  const [secondOrgWord, setSecondOrgWord] = useState<any>();
  const [showLoader, setShowLoader] = useState(false);
  const [pwdSecondsLeft, setPwdSecondsLeft] = useState<number | null>(null);
  const [pwdWarnDismissed, setPwdWarnDismissed] = useState(false);
  const pwdWarningThreshold = parseInt(
    process.env.REACT_APP_PASSWORD_EXPIRY_WARNING_SECONDS || '432000',
    10
  );

  useEffect(() => {
    const update = () => {
      const secs = getSecondsUntilPasswordExpiry();
      console.log('[PwdExpiry] secondsLeft:', secs, 'threshold:', pwdWarningThreshold);
      setPwdSecondsLeft(secs);
    };
    update();
    const interval = setInterval(update, 5000);
    return () => clearInterval(interval);
  }, []);
  const channel = new BroadcastChannel("convay");
  const profileChange = useSelector(
    (state: RootState) => state.resource.profilePicChange,
  );
  const dispatch = useDispatch();

  const orgInfo = useSelector((state: RootState) => state.organization.orgInfo);

  const isMatrixChatDisplayed = useSelector(
    (state: RootState) => state.matrix.isChatVisible,
  );

  const onClickShowMainMenu = (val: boolean) => {
    // Keep header actions (profile card/menu trigger) always visible on mobile.
    // Sidebar open/close must not hide header content.
    if (windowWidth <= 768) {
      setMainMenuVisible(true);
      return;
    }
    setMainMenuVisible(val);
  };

  const onClickShowProfileMenu = (val: boolean) => {
    setUserMenuVisible(val);
  };
  const iframeRef = useSelector((state: RootState) => state.matrix.iframeRef);
  const { width: windowWidth } = useOnWindowResize();

  const clearStorageAndCookies = () => {
    const currentDomain = window.location.hostname;

    // Only clear cookies for the exact current domain — do NOT sweep parent domain
    // to avoid interfering with other apps on sibling subdomains (e.g. mid.convay.com)
    const domainsToTry = [currentDomain, `.${currentDomain}`];

    // Clear localStorage and sessionStorage
    try {
      localStorage.clear();
      sessionStorage.clear();
    } catch (e) {
      console.error("Failed to clear storage:", e);
    }

    // Clear all cookies across all domain variants
    const cookies = Cookies.get();
    Object.keys(cookies).forEach((cookieName) => {
      try {
        Cookies.remove(cookieName);
        Cookies.remove(cookieName, { path: "/" });
        domainsToTry.forEach((domain) => {
          Cookies.remove(cookieName, { domain, path: "/" });
        });
      } catch (e) {
        console.error(`Failed to remove cookie ${cookieName}:`, e);
      }
    });

    // Additional cleanup for secure cookies via document.cookie
    document.cookie.split(";").forEach((cookie) => {
      const cookieName = cookie.split("=")[0].trim();
      const expiry = "expires=Thu, 01 Jan 1970 00:00:00 GMT";
      document.cookie = `${cookieName}=; ${expiry}; path=/`;
      domainsToTry.forEach((domain) => {
        document.cookie = `${cookieName}=; ${expiry}; path=/; domain=${domain}; secure`;
      });
    });
  };

  const logoutSubmitHandler = async () => {
    setShowLoader(true);
    setUserMenuVisible(true);
    const delay = (ms: number) =>
      new Promise((resolve) => setTimeout(resolve, ms));

    setMixpanelEventForLogOut(useJwtToken());

    const authObject = useJwtToken();

    // Fire-and-forget — never block logout on Firebase
    if (authObject?.user?.user_email) {
      writeLogoutEvent(authObject?.user?.user_email).catch(() => {});
    }

    if (authObject?.matrixAccessToken) {
      matrixUserLogout(authObject?.matrixAccessToken);
    }

    // Send a logout message to the iframe
    if (iframeRef) {
      await delay(1000);
      iframeRef.contentWindow?.postMessage("logout", "*");
    }

    let logoutTimeout: any;

    // Fallback to logout if "logout_complete" is not received within 5 seconds
    const forceLogout = () => {
      // console.log("Logout timeout: forcing logout.");
      clearStorageAndCookies();
      channel.postMessage("logout!!");
      setShowLoader(false);
      dispatch(userLogout(true));
      // console.log("triggered in web");
      history.push("/sign-in");
      window.location.replace("/sign-in");
    };

    // Set the timeout to force logout after 5 seconds
    logoutTimeout = setTimeout(forceLogout, 5000);

    if (isMatrixChatDisplayed) {
      // Listen for the confirmation message from the iframe
      window.addEventListener("message", (event) => {
        if (event.data === "logout_complete") {
          // console.log("Logout completed in iframe");

          // Clear the timeout if logout was successful before the timeout
          clearTimeout(logoutTimeout);

          // Perform parent logout actions
          clearStorageAndCookies();
          channel.postMessage("logout!!");
          dispatch(userLogout(true));
          setShowLoader(false);
          // console.log("triggered in web");
          history.push("/sign-in");
          window.location.replace("/sign-in");
        }
      });
    } else {
      clearStorageAndCookies();
      channel.postMessage("logout!!");
      dispatch(userLogout(true));
      setShowLoader(false);
      // console.log("triggered in web");
      history.push("/sign-in");
      window.location.replace("/sign-in");
    }
  };

  const logoutFromDesktop = async (): Promise<void> => {
    setShowLoader(true);
    setUserMenuVisible(true);
    let logoutTimeout: any;

    const authObject = useJwtToken();

    // Fire-and-forget — never block logout on Firebase
    if (authObject?.user?.user_email) {
      writeLogoutEvent(authObject.user.user_email).catch(() => {});
    }

    if (!authObject?.matrixAccessToken) {
      matrixUserLogout(authObject?.matrixAccessToken);
    }

    // Fallback to logout if "logout_complete" is not received within 5 seconds
    const forceLogout = () => {
      // console.log("Logout timeout: forcing logout.");
      clearStorageAndCookies();
      channel.postMessage("logout!!");
      setShowLoader(false);
      dispatch(userLogout(true));
      // console.log("triggered in Electron");
      history.push("/sign-in");
      window.location.replace("/sign-in");
    };

    // Set the timeout to force logout after 5 seconds
    logoutTimeout = setTimeout(forceLogout, 5000);

    if (isMatrixChatDisplayed) {
      // Listen for the confirmation message from the iframe
      window.addEventListener("message", (event) => {
        if (event.data === "logout_complete") {
          // console.log("Logout completed in iframe");

          // Clear the timeout if logout was successful before the timeout
          clearTimeout(logoutTimeout);

          const logoutDeepLink = document.createElement("a");
          logoutDeepLink.href = `${environment.deeplinkAppPrefix}://logout`;
          const authLinks = document.getElementById(
            "cnv-auth-links",
          ) as HTMLElement;
          authLinks.appendChild(logoutDeepLink);

          setShowLoader(false);
          // console.log("Triggered in Electron");
          logoutDeepLink.click();
          Cookies.remove("auth_token");
        }
      });
    } else {
      const logoutDeepLink = document.createElement("a");
      logoutDeepLink.href = `${environment.deeplinkAppPrefix}://logout`;
      const authLinks = document.getElementById(
        "cnv-auth-links",
      ) as HTMLElement;
      authLinks.appendChild(logoutDeepLink);

      // console.log("Triggered in Electron");
      logoutDeepLink.click();
      Cookies.remove("auth_token");
      channel.postMessage("logout!!");
      setShowLoader(false);
      setMixpanelEventForLogOut(useJwtToken());
      dispatch(userLogout(true));
      // Clear the timeout if logout actions are completed manually before timeout
      clearTimeout(logoutTimeout);
    }
  };

  useOutsideHeaderMenuClick(
    onClickShowMainMenu,
    (val: boolean) => {
      // Only allow closing menu if not in logout process
      if (!showLoader) {
        setUserMenuVisible(val);
      }
    },
    containerRef,
    clickRef,
    menuRef,
    burgerRef,
    windowWidth,
    userMenuVisible,
  );

  useEffect(() => {
    windowWidth > 768 ? setMainMenuVisible(true) : setMainMenuVisible(true);
    setUserMenuVisible(false);
    if (!showLoader) {
      setMainMenuVisible(true);
    }
  }, [windowWidth]);

  useEffect(() => {
    if (!userInfo?.user.ID) return;

    getUserProfilePicById(userInfo?.user.ID)
      .then((res) => {
        if (res.data) {
          // Check if res.data is already a full URL
          const isUrl =
            res.data.startsWith("http://") || res.data.startsWith("https://");
          const finalUrl = isUrl
            ? res.data
            : environment.fileServiceApi + "file/" + res.data;
          setPictureUrl(finalUrl);
          setImageLoadError(false); // Reset error state when new image URL is set
        } else {
          setPictureUrl("");
          setImageLoadError(false);
        }
      })
      .catch((err) => {
        setPictureUrl("");
        setImageLoadError(false);
      });
  }, [profileChange, userInfo?.user.ID]);

  useEffect(() => {
    getUserDetailsByUserId(userInfo?.user.ID).then((res: any) => {
      if (res.data.name) {
        setUserName(res.data.name);
        const nameArray = res.data.name.toUpperCase().split(" ");
        setUserAvatarLetter(
          nameArray.length > 1
            ? nameArray[0].substring(0, 1) + nameArray[1].substring(0, 1)
            : nameArray[0].substring(0, 1),
        );
      } else setUserAvatarLetter(res.data.email.toUpperCase().substring(0, 1));
      if (res.data?.language) {
        setLanguage(res.data.language.toLowerCase());
      } else {
        setLanguage("en");
      }
    });
  }, []);
  useEffect(() => {
    /*
     * get all information of an organization
     */
    getOrganizationInfo(userInfo?.user.organization_id).then((res: any) => {
      setOrganizationName(res.data.org_name);
      let str = res.data.org_name;
      str = str.replace(/(^\s*)|(\s*$)/gi, "");
      str = str.replace(/[ ]{2,}/gi, " ");
      str = str.replace(/\n /, "\n");
      let length = str.split(" ").length;
      let firstWordOrg = res.data.org_name.split(" ").slice(0, 1).join("");
      if (firstWordOrg) {
        setFirstOrgWord(firstWordOrg[0].toUpperCase());
      }
      if (length > 1) {
        let secondWordOrg = res.data.org_name.split(" ").slice(1, 2).join("");
        setSecondOrgWord(secondWordOrg[0].toUpperCase());
      }
      setOrganizationLogo(res.data.org_logo);
    });
  }, [orgInfo]);

  return (
    <nav
      id="cnv-top-nav"
      data-testid="header-nav"
      className={`${isMobile ? "cnv-top-nav-mobile-browser" : "cnv-top-nav"} ${styles.main}`}
    >
      {/*<div>*/}
      {/*  <div className="cnv-org-name">*/}
      {/*    {organizationLogo ? (*/}
      {/*      <img*/}
      {/*        src={environment.fileServiceApi + "file/" + organizationLogo}*/}
      {/*      />*/}
      {/*    ) : organizationName ? (*/}
      {/*      <span>*/}
      {/*        {" "}*/}
      {/*        {!secondOrgWord ? firstOrgWord : firstOrgWord + secondOrgWord}*/}
      {/*      </span>*/}
      {/*    ) : null}*/}

      {/*    {organizationName}*/}
      {/*  </div>*/}
      {/*</div>*/}

      {!pwdWarnDismissed && pwdSecondsLeft !== null && pwdSecondsLeft > 0 && pwdSecondsLeft <= pwdWarningThreshold && (
        <div style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)', display: 'flex', alignItems: 'center', gap: '10px', fontSize: '13px', color: '#856404', background: '#fff3cd', padding: '6px 12px', borderRadius: '4px', border: '1px solid #ffc107', whiteSpace: 'nowrap' }}>
          <span>{t("password_will_expire_in")} <strong>{formatPwdTimeLeft(pwdSecondsLeft)}</strong>. {t("please_change_it")}</span>
          <button
            onClick={() => history.push('/force-change-password')}
            style={{ padding: '4px 10px', background: '#856404', color: '#fff', border: 'none', borderRadius: '4px', fontSize: '12px', cursor: 'pointer', fontWeight: 600, whiteSpace: 'nowrap' }}
          >
            {t("change_password")}
          </button>
          <button
            onClick={() => setPwdWarnDismissed(true)}
            aria-label="Dismiss"
            style={{ background: 'none', border: 'none', color: '#856404', fontSize: '16px', cursor: 'pointer', lineHeight: 1, padding: '0 2px' }}
          >
            ✕
          </button>
        </div>
      )}
      <div className="cnv-top-nav-right">
        <ul
          ref={menuRef}
          style={{ display: mainMenuVisible ? "block" : "none" }}
        >
          {/* <li className="cnv-tooltips">
            <Link to="#" className="cnv-whats-new cnv-link">
              <WhatsNewIcon />
              {" " + `What's new`}
            </Link>
          </li> */}
          <li className="cnv-tooltips" style={{ display: "none" }}>
            <a className="cnv-link cnv-quick-action">
              <SvgQuickActionIcon /> {" " + "Quick Action"}
            </a>
          </li>
          {/* <li className="cnv-tooltips">
            <Link to="#" className="cnv-link">
              <MenuCalendarIcon />
            </Link>
          </li> */}
          {/* <li className="cnv-tooltips">
            <Link to="#" className="cnv-link">
              <SettingsHexaIcon />
            </Link>
          </li> */}
          <li className="cnv-tooltips" style={{ display: "none" }}>
            <Link to="#" className="cnv-link">
              <SvgBellIcon />
            </Link>
          </li>

          <li>
            <div
              id="user-dropdown-menu"
              data-testid="header-user-menu"
              className={`cnv-profile-icon-wrapper ${
                userMenuVisible ? "cnv-rotate-180" : ""
              }`}
              ref={clickRef}
              // style={{ display: windowWidth > 768 ? "block" : "none" }}
            >
              <a
                id="header-profile-avatar"
                data-testid="header-profile-avatar"
                className="cnv-profile-icon cnv-link"
              >
                {!pictureUrl || imageLoadError ? (
                  <span>{userAvatarLetter}</span>
                ) : (
                  <img
                    src={pictureUrl}
                    alt="Profile"
                    referrerPolicy="no-referrer-when-downgrade"
                    onError={() => setImageLoadError(true)}
                  />
                )}
              </a>
              <span className="user-name">
                {userName} <SubMenuDownArrow />
              </span>
            </div>
            <ul
              style={{ display: userMenuVisible ? "block" : "none" }}
              ref={containerRef}
              id="cnv-auth-links"
            >
              <li>
                <a
                  id="header-profile-link"
                  data-testid="header-profile-link"
                  className="cnv-link"
                  onClick={() => {
                    setUserMenuVisible(false);
                    history.push("/profile");
                    setChatClass(false);
                    dispatch(setMatrixState(false));
                  }}
                >
                  {t("profile")}
                </a>
              </li>
              {/* <li>
                <a className="cnv-link">
                  Billing info
                </a>
              </li>
              <li>
                <a className="cnv-link">
                  Subscription
                </a>
              </li> */}
              <li>
                {/* <a href={logOutUrl} className="cnv-link">
                  Logout
                </a> */}

                <a
                  id="header-logout-btn"
                  data-testid="header-logout-btn"
                  className="cnv-link"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    color: showLoader ? "#a9aebf" : "",
                    cursor: showLoader ? "not-allowed" : "",
                  }}
                  onClick={() =>
                    isElectron() ? logoutFromDesktop() : logoutSubmitHandler()
                  }
                >
                  {t("logout")}
                  {showLoader && (
                    <Loader
                      isCircular={true}
                      circleStyle={{
                        borderColor:
                          "var(--brand, #365d7e) transparent transparent transparent",
                      }}
                    />
                  )}
                </a>
              </li>
            </ul>
          </li>
        </ul>
        {/* <HamburgerIcon className="cnv-mobile-menu" /> */}
        {/*<div ref={burgerRef}>*/}
        {/*  <HamburgerIcon style={{ cursor: "pointer" }} />*/}
        {/*</div>*/}
      </div>
    </nav>
  );
}
